import {Base64} from 'js-base64';

import {ChemicalFileFormat} from 'chemistry/ChemistryConstants';

export const IS_CHEMICAL_FILE_FORMAT_BINARY: Record<ChemicalFileFormat, boolean> = {
  [ChemicalFileFormat.CDX]: true,
  [ChemicalFileFormat.MOL]: false,
  [ChemicalFileFormat.SMILES]: false,
  [ChemicalFileFormat.INCHI]: false,
  [ChemicalFileFormat.RDF]: false,
  [ChemicalFileFormat.MRV]: false,
  [ChemicalFileFormat.SDF]: false,
};

export async function getChemicalFileContent(
  fileFormat: ChemicalFileFormat,
  content: Blob | Response
): Promise<string> {
  if (IS_CHEMICAL_FILE_FORMAT_BINARY[fileFormat]) {
    const buffer = await content.arrayBuffer();
    // Convert file content bytes to a base64 string for binary file formats.
    return Base64.fromUint8Array(new Uint8Array(buffer));
  } else {
    return await content.text();
  }
}
